import React from "react";
import Cross from './pics/svg/cross.svg';
import Nc from './pics/nc.png';
import Chevron from './pics/svg/chevron.svg';
import Netflix from './pics/services/netflix.png';
import Prime from './pics/services/prime.png';
import Amazon from './pics/services/amazon.png';
import Disney from './pics/services/disney.png';
import Apple from './pics/services/apple.png';
import YouTube from './pics/services/youtube.png';
import Google from './pics/services/google.png';
import iTunes from './pics/services/itunes.png';
import Tubi from './pics/services/tubi.png';
import Hulu from './pics/services/hulu.png';
import Crunchyroll from './pics/services/crunchyroll.png';
import Skygo from './pics/services/skygo.png';
import BBC from './pics/services/bbc.png';
import Four from './pics/services/four.png';
import Showtime from './pics/services/showtime.png';
import HBO from './pics/services/hbo.png';
import Spongebob from './pics/gifs/spongebob.gif'
import Watching from './pics/gifs/watching.gif'
import AppIcon from './pics/app.png'
import "./about.css";

function About(){

    function closeAbout() {
        document.querySelector('.sticky .close').style.pointerEvents = "none"
        document.querySelector('.about-wrapper').style.transform = "scale(0.8)"
        document.querySelector('.about-wrapper').style.opacity = 0
        document.querySelector('.about-wrapper').style.pointerEvents = "none"
        hideDropdown()
    }

    function hideDropdown() {
        document.querySelector('.nav-bar').classList.add('hideNav')
        document.querySelectorAll('.nav-bar button:not(.dropdown)').forEach(button => {
            button.classList.remove('slideIn')
        })
        document.querySelector('.nav-bar').style.pointerEvents = "none"
        document.documentElement.style.setProperty('--nav-blur', 'blur(0px)')
        document.documentElement.style.setProperty('--dropdown-rotate', 'rotate(90deg)')
    }

    function injectEmoji(status) {
        let emoji
        status === "yep" ? emoji = "✅" : emoji = "⏳"
        return emoji
    }

    function onDownClick() {
       let about = document.querySelector('.about-container .about'),
       heightOfScroll;
       window.innerWidth > 800 ? heightOfScroll = 600 : heightOfScroll = window.innerHeight*0.9
        about.scrollTo({
            top: heightOfScroll,
            left: 0,
            behavior: 'smooth'
        });
    }

    return (
        <div className="about-wrapper">
            <div className="about-container">
                <div className="about">
                    <div className="sticky">
                        <img onClick={closeAbout} className="close" src={Cross} alt="X" />
                    </div>
                    <div className="front-container">
                        <section className="front">
                            <img src={AppIcon} alt="App Icon" />
                            <span className="title">WatchWhere</span>
                            <span className="about-heading">The Simple Streaming Service Search Engine <span role="img" aria-label="">🍿🔍</span></span>
                            <img onClick={onDownClick} className="down" src={Chevron} alt="(scroll)"/>
                        </section>
                    </div>
                    <div className="struggle">You ever struggled to find a show and had to resort to Googling <em>“where to watch…”</em>?</div>
                    <img className="sponge" src={Spongebob} alt="" />
                    <div className="notfun">…not a fun time, is it? <span role="img" aria-label="frustrated">😤</span></div>
                    <div className="power">WatchWhere ties together powerful APIs to collect metadata from streaming services across the internet.</div>
                    <div className="watching"><span>So, what does this mean?</span> It means you spend less time searching, and more time watching. Just search for a show, and you'll see exactly where it's available to watch or buy.</div>
                    <img className="sponge" src={Watching} alt="" />
                    <div className="somewhere">On top of that, if you're a Netflix person and you're sad that your show isn't on Netflix, I've got good news: <span>it's probably on Netflix somewhere in the world</span>. <br /><br /> WatchWhere will tell you exactly where it is available, so you can quickly fire up your favourite VPN and get straight to watching.</div>
                    <img className='net' src={Nc} alt="NETFLIX"/>
                    <div className="netflix-button">Press this button, under each show, to find every country where that show is available on Netflix.</div>
                    <h5>Supported Services:</h5>
                    <div className="servs">
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={Netflix} alt="Netflix"></img><span>Netflix</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={Prime} alt="Prime"></img><span>Prime</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={Disney} alt="Disney"></img><span>Disney+</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={Apple} alt="Apple"></img><span>Apple TV</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={YouTube} alt="YouTube"></img><span>YouTube</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={Amazon} alt="Amazon"></img><span>Amazon</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={Google} alt="Google"></img><span>Google Play</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={iTunes} alt="iTunes"></img><span>iTunes Store</span></div></div>
                        <div className="serv">{injectEmoji('yep')} <div className="icon"><img src={Tubi} alt="Tubi"></img><span>Tubi</span></div></div>
                        <div className="serv nope" >{injectEmoji('nope')} <div className="icon"><img src={Hulu} alt="Hulu"></img><span>Hulu</span></div></div>
                        <div className="serv nope" >{injectEmoji('nope')} <div className="icon"><img src={Crunchyroll} alt="Crunchyroll"></img><span>Crunchyroll</span></div></div>
                        <div className="serv nope" >{injectEmoji('nope')} <div className="icon"><img src={Skygo} alt="Sky Go"></img><span>Sky Go</span></div></div>
                        <div className="serv nope" >{injectEmoji('nope')} <div className="icon"><img src={BBC} alt="BBC iPlayer"></img><span>BBC iPlayer</span></div></div>
                        <div className="serv nope" >{injectEmoji('nope')} <div className="icon"><img src={Four} alt="Four"></img><span>All 4</span></div></div>
                        <div className="serv nope" >{injectEmoji('nope')} <div className="icon"><img src={Showtime} alt="Showtime"></img><span>Showtime</span></div></div>
                        <div className="serv nope" >{injectEmoji('nope')} <div className="icon"><img src={HBO} alt="HBO"></img><span>HBO Max</span></div></div>
                    </div>
                    <h5 className="happy">
                        <span role="img" aria-label="">🌞</span> <span className="txt">Happy Streaming!</span> <span role="img" aria-label="">💎</span>
                </h5>
                </div>
                
            </div>
        </div>
    )
}

export default About;
